import ExpiredMagicLink from '@src/components/ExpiredMagicLink/ExpiredMagicLink';
import { getSharedServerSideProps } from '@src/utils/serverside/get-shared-serverside-props';
export default function Expiration() {
  return <ExpiredMagicLink data-sentry-element="ExpiredMagicLink" data-sentry-component="Expiration" data-sentry-source-file="index.page.tsx" />;
}
export const getServerSideProps = async context => {
  return getSharedServerSideProps(context, {
    shouldFetchAppData: true
  });
};